import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import type { OmitStylesHTMLAttributes } from '../../types';

export const tagsVariants = cva('rocco-tags inline-flex items-center', {
    variants: {
        variant: {
            default: 'gap-2',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

interface TagsProps
    extends
        OmitStylesHTMLAttributes<HTMLDivElement>,
        VariantProps<typeof tagsVariants> {}

export const Tags = ({ children, variant, ...props }: TagsProps) => (
    <div className={tagsVariants({ variant })} {...props}>
        {children}
    </div>
);
